import { computed } from "vue";

import { useYChannelStoreHook } from "../store/channel";

/**
 * 获取定制组件
 * @param key 组件key
 * @returns 组件
 */
export const useCustomComponent = (key: string) => {
  const channelStore = useYChannelStoreHook();
  const component = computed(() => {
    return channelStore.configs?.components?.[key];
  });
  return {
    component
  };
};
